<template>
  <b-container fluid>
    <ValidationObserver ref="observer" v-slot="{ invalid }" class="tsny_form">
      <div v-if="!submitted">
        <b-row>
          <b-col>
            <div class="tsny_header mb-5 pt-3">Ask a Question</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-4">
            <b-form-group label="Course">
              <b-select
                v-model="course"
                :options="courseOptions"
                class="form-control"
              ></b-select>
            </b-form-group>
          </b-col>
          <b-col>
            <BTextInputValidated
              v-model="topic"
              label="Topic"
              placeholder="Writing, Division, GRE Strategies, etc."
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BTextInputValidated
              v-model="question"
              rules="required"
              label="Question"
              placeholder="How do I factor? How do I solve question 3 in Math 1 of practice test x?"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BTextInputValidated
              v-model="description"
              text-area
              label="Details"
              placeholder="Please describe your question. If it relates to a specific review book, let us know which one and what chapter and page number. If it's about a practice exam question, make sure you indicate the exam, section, and question."
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              class="tsny_button"
              :disabled="invalid"
              @click="askQuestion"
              >Post</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p v-if="questionError" class="tsny_status-text">
              An error occurred submitting your question. Please try again in a
              few minutes
            </p>
          </b-col>
        </b-row>
      </div>
      <b-row style="margin-top: 250px" v-if="submitted"
        ><b-col>
          <p class="tsny_status-text">
            Your question has been submitted! An instructor will follow up with
            you to provide assistance
          </p>
        </b-col></b-row
      >
    </ValidationObserver>
  </b-container>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";
import { mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
import QuestionBankRestService from "../../services/rest/services/QuestionBankRestService";

export default {
  name: "QuestionForm",
  components: {
    BTextInputValidated,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      defaultCourse: StoreConstants.GETTERS.COURSE,
      courseObjects: StoreConstants.GETTERS.COURSE_OBJECTS
    }),
    courseOptions() {
      let options = [
        {
          value: "General",
          text: "General Question"
        }
      ];

      for (let i = 0; i < this.courseObjects.length; i++) {
        options.push({
          value: this.courseObjects[i]._id,
          text: this.courseObjects[i]._id
        });
      }

      return options;
    }
  },
  data() {
    return {
      course: null,
      topic: null,
      question: null,
      description: null,
      questionError: null,
      submitted: null
    };
  },
  methods: {
    async askQuestion() {
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.questionError = false;

      try {
        await QuestionBankRestService.submitQuestion({
          course: $comp.course,
          topic: $comp.topic,
          question: $comp.question,
          description: $comp.description
        });
        $comp.submitted = true;
      } catch (err) {
        console.log(err);
        $comp.questionError = true;
      }
    }
  }
};
</script>

<style scoped></style>
